function getFirstItem(sortedItems) {
  return sortedItems[0];
}

function getLastItem(sortedItems) {
  return sortedItems[sortedItems.length - 1];
}

function getNextItem(sortedItems, activeItem) {
  const focusedIndex = sortedItems.findIndex(el => el === activeItem);
  const indexToFocus = focusedIndex + 1;

  if (indexToFocus < sortedItems.length) {
    return sortedItems[indexToFocus];
  } else {
    return getFirstItem(sortedItems);
  }
}

function getPrevItem(sortedItems, activeItem) {
  const focusedIndex = sortedItems.findIndex(el => el === activeItem);
  const indexToFocus = focusedIndex - 1;

  if (indexToFocus >= 0) {
    return sortedItems[indexToFocus];
  } else {
    return getLastItem(sortedItems);
  }
}

function htmlElementsComparator(a, b) {
  if (a.offsetTop > b.offsetTop) {
    return 1;
  }

  if (a.offsetTop < b.offsetTop) {
    return -1;
  }

  if (a.offsetLeft > b.offsetLeft) {
    return 1;
  }

  if (a.offsetLeft < b.offsetLeft) {
    return -1;
  }

  return 0;
}

export { getFirstItem, getLastItem, getNextItem, getPrevItem, htmlElementsComparator };
